import Splide from '@splidejs/splide';
import { Translations } from '../utils';
import './etica-slider.scss';

export class EticaSlider {
  constructor() {
    this.el = document.querySelector('.js-etica-slider');
    if (!this.el) return;

    this.init();
  }

  init() {
    const perPage = this.el.dataset.perPage || 4;
    const splide = new Splide(this.el, {
      type: 'slide',
      arrows: true,
      pagination: false,
      gap: '24px',
      perPage: parseInt(perPage, 10),
      focus: 0,
      destroy: false,
      drag: true,
      trimSpace: true,
      snap: true,
      breakpoints: {
        992: {
          perPage: 2.2,
        },
        767: {
          perPage: 1.2,
        },
      },
      i18n: Translations.getSplideI18n(),
    });

    splide.mount();

    const prev = this.el.querySelector('.splide__arrow--prev');
    const next = this.el.querySelector('.splide__arrow--next');
    const updateArrows = () => {
      if (!window.matchMedia('(min-width: 992px)').matches) return;
      const { index } = splide;
      const last = splide.length - splide.options.perPage;

      // Se sono all’ultima slide disabilito next
      if (index >= last) {
        next.classList.add('is-disabled');
      } else {
        next.classList.remove('is-disabled');
      }

      if (splide.length <= splide.options.perPage) {
        prev.classList.add('is-removed');
        next.classList.add('is-removed');
      }
    };

    // primo chek al caricamento
    updateArrows();
    // secondo check al cambio slide
    splide.on('mounted move', updateArrows);
  }
}
